import React from 'react';
import { Sparkle } from '@phosphor-icons/react';
interface ProfileCompletenessNudgeProps {
  percent: number; // 0–100
  missingFields: string[]; // human-readable list, e.g. ['bio', 'facilități']
  onPrimaryAction?: () => void;
  primaryLabel?: string;
}
// Nudge appears when profile is < 100% complete.
// In cold start (no stats yet), this is the visual hero of the top section —
// gives the user a single clear thing to do.
export function ProfileCompletenessNudge({
  percent,
  missingFields,
  onPrimaryAction,
  primaryLabel = 'Completează profilul'
}: ProfileCompletenessNudgeProps) {
  if (percent >= 100) return null;
  const clamped = Math.max(0, Math.min(100, percent));
  const missingText = missingFields.length === 0 ? '' : missingFields.length === 1 ? missingFields[0] : missingFields.length === 2 ? missingFields.join(' și ') : `${missingFields.slice(0, -1).join(', ')} și ${missingFields[missingFields.length - 1]}`;
  return <div className="rounded-2xl bg-dark-2 border border-dark-3 p-4 sm:p-5 flex items-start gap-4" data-id="element-727">
      <div className="w-10 h-10 rounded-xl bg-lime-5 border border-lime-4 flex items-center justify-center shrink-0" data-id="element-728">
        <Sparkle size={18} weight="duotone" className="text-lime-1" data-id="element-729" />
      </div>
      <div className="flex-1 min-w-0" data-id="element-730">
        <div className="flex items-center justify-between gap-3 mb-2" data-id="element-731">
          <p className="text-sm font-semibold text-light-1" data-id="element-732">
            Profil {clamped}% complet
          </p>
          {onPrimaryAction && <button onClick={onPrimaryAction} className="text-xs font-medium text-lime-1 hover:text-lime-2 cursor-pointer shrink-0" data-id="element-733">
              {primaryLabel} →
            </button>}
        </div>
        {/* Progress bar */}
        <div className="h-1.5 rounded-full bg-dark-3 overflow-hidden" data-id="element-734">
          <div className="h-full bg-lime-1 transition-all duration-500" style={{
          width: `${clamped}%`
        }} data-id="element-735" />
        </div>
        {missingText && <p className="text-xs text-light-3 mt-2.5 leading-relaxed" data-id="element-736">
            Adaugă {missingText} ca să primești cu 3× mai multe oferte.
          </p>}
      </div>
    </div>;
}